import React, { Component } from "react"
import { Row, Col, FormGroup,Panel,Button, FormControl  } from "react-bootstrap"
import { connect } from 'react-redux'
import { object } from "prop-types"
import moment from 'moment'
import DatePicker from 'react-datepicker';
import { getUserRole } from '../../redux/actions/action_user'
import { isEmpty } from '../../utils/functions'
import { 
	blue,
	videoblue,
	userIcon,
	submittingIcon,
	applicationId,
	messageType,
	applicationrole,
} from '../../utils/constants'
import { membersearch } from '../../utils/api'
import logo from '../../images/logo.png'
import background  from '../../images/background.jpg'
import userManager from '../../userManager'
import requestAccess from './api/requestAccess'
import { pendingRequest, RequestStatus, UserMessages } from './logic'
import UserMessage from './component/usermessage'
import "react-datepicker/dist/react-datepicker.css";
import './index.css'

const verticalAlign = {
  position: 'relative',
  left:'20%'
}
 
const pageBackground = {
  backgroundImage: `url(${background})`,
	height:'100%',
	paddingTop:'10%'
}

const readOnly = {
	borderWidth:'0',
	backgroundColor:'white', 
	fontWeight:'bold',
	fontSize: '16px'
}

class UserRegistration extends Component {

  constructor(props)
  {
		super(props)    
		this.state = {
			prefix:'',
			suffix:'',
			dob:null,
			firstName:'',
			lastName:'',
			emailAddress:'',
			submitting:false,
			accountFound:false,
			searching:false,
			missingMemberId:false,
			searchFound:true,
			saving: false,
			requestSuccessful: false,
			requestSubmitted: false,
			ssoMembershipMismatch: false
		}
		this.handleMemberSearch  = this.handleMemberSearch.bind(this)
		this.handleRequestAccess = this.handleRequestAccess.bind(this)
		this.handleOnChange      = this.handleOnChange.bind(this)
		this.handleSignOut = this.handleSignOut.bind(this)
		this.handleJoinNow = this.handleJoinNow.bind(this)
		this.handleForgotMemberId = this.handleForgotMemberId.bind(this)
		this.handleDateChange  = this.handleDateChange.bind(this)
	}
	componentDidMount()
	{
		const { oidc } = this.props
		const _this = this
	
		if (oidc.user === null)
		{
			userManager.signinRedirect().then(function() {
				_this.props.dispatch(getUserRole())
			})
		}
		else
		{	
			_this.props.dispatch(getUserRole())
		} 
	}

	handleDateChange(value) {
		this.setState({ dob:value })
	}
 
  handleOnChange(evt) {
		const ctrl = evt.target.id
		const val   = evt.target.value

		this.setState({ 
			[ctrl]:val,
			missingMemberId: false,
			firstName:'',
			lastName:'',
			emailAddress:'',
			accountFound:false,
			searchFound:true,
			ssoMembershipMismatch: false 
		})
	}

  handleSignOut()
  {
    userManager.signoutRedirect()
	}
	handleJoinNow(evt)
	{
		evt.preventDefault()
		window.open('https://apps.bowl.com/AssociateMembership/main.aspx', '_blank')
	}
	handleForgotMemberId(evt)
	{
		evt.preventDefault()
		window.open('https://webapps.bowl.com/USBCFindA/Home/MemberLookup', '_blank')
	}
  handleMemberSearch(evt) {
		const { prefix,suffix, dob } = this.state
				
		if(!isEmpty(prefix) && !isEmpty(suffix) && (dob !== null))
    {
			const { user } = this.props.oidc
			const token = user.access_token
			const _this = this
			let ssoMembershipMismatch = false
			let accounFound = true
			
			this.setState({ searching:true,missingMemberId: false })

      membersearch(prefix,suffix,token).then(function(result) {
				const member = result.data.value
				const { firstName, lastName, emailAddress, birthdate } = member
				const {  dob } = _this.state
			
				// make sure SSO info and membership info match
				if(moment(birthdate).format('L') !== dob.format('L') )
				{
					ssoMembershipMismatch = true;
					accounFound = false;
				}
        
				_this.setState({
					firstName,
					lastName,
					emailAddress,
					searching:false,
					accountFound:true,
					searchFound:true,
					requestSubmitted:false,
					ssoMembershipMismatch,
					accounFound
				})
      }).catch(function() {
				_this.setState({ searching:false,accountFound:false,searchFound:false })
			})
		}
		else
		{
			this.setState({ searching:false, missingMemberId:true })
		}
		evt.preventDefault()
  }

  handleRequestAccess() {
    const { 
			prefix,
			suffix,
			firstName,
			lastName,
			dob,
			emailAddress 
		} = this.state
		const { user } = this.props.oidc
		const token = user.access_token
		const ssoUserId =  user.profile.sub
		const _this = this

		this.setState({ saving: true })

		requestAccess(prefix,suffix,firstName,lastName,dob,emailAddress, applicationId, applicationrole.Director, ssoUserId,token).then(function(result){
      if (result.error) {
        _this.setState({ saving: false  });
      } else {
        const requestSuccessful = result.data

        _this.setState({ saving: false, requestSuccessful, requestSubmitted: true })
      }
    }).catch(function() {
      _this.setState({ saving: false });
    });
  }

  render()
  {
    const { 
			submitting,
			firstName,
			lastName,
			emailAddress,
			accountFound,
			searching,
			missingMemberId,
			prefix,
			suffix,
			searchFound,
			saving,
			requestSubmitted,
			requestSuccessful,
			ssoMembershipMismatch
		} = this.state

		const { status } = this.props.user;
		
		const searchicon = userIcon(searching)

		const requestStatus = pendingRequest(status);

		const pendingAccessRequest = (requestStatus === RequestStatus.PendingApproval);

		const promptUser = (pendingAccessRequest === false && requestSubmitted === false );

		const heading = pendingAccessRequest ? UserMessages.PendingAccessRequest :  UserMessages.CompleteAccessRequest;

    return (
    <div className='col-sm-12' style={pageBackground} >
      <Row className='col-sm-7' style={verticalAlign}>
      <Col>
        <Panel sm={10} >
          <div className="panel-heading text-center" style={{ paddingTop:'30px' }} sm={2} >
            <img src={logo} alt="Image" className="img-rounded pull-left" style={{ marginTop:'-30px',marginLeft:'-40px', paddingLeft:'0', width:'227px', height:'50px' }} /> 
						<h3>{heading}</h3>
          </div> 
					<div className="pull-right" sm={1} style={{ marginTop:'-80px' }} >
						{ promptUser && 
							(<span  style={{ fontSize:'16px', padding:'0' }}>
								Not a Member?<button className="btn btn-default" style={{ color: videoblue, fontSize:'16px', border:'0', textDecoration: 'underline', marginTop:'-5px', padding:'6px' }} onClick={this.handleJoinNow}>Join now!</button>
							</span>)
						}
						<button className="btn btn-default" style={{ color: blue, fontSize:'16px', marginRight:'5px', marginLeft:'10px' }} onClick={this.handleSignOut}>Logout</button>
          </div>
					<div sm={12}>
          { 
						promptUser &&
						(<h4 style={{ marginTop:'-8px', marginLeft:'18px' }}>{UserMessages.EnterInfo}</h4>)
					}
						<hr style={{ color:'rgb(7,30,98)' }}/>
					{ 
						missingMemberId && 
						(<UserMessage message={UserMessages.MissingMemberId} type={messageType.Warning} />) 
					}
					{ 
						!searchFound && 
						(<UserMessage message={UserMessages.InvalidId} type={messageType.Warning} />) 
					}
          { 
						ssoMembershipMismatch && 
						(<UserMessage message={UserMessages.MismatchInfo} type={messageType.Warning} />)
					}
          { 
						accountFound && !emailAddress && 
						(<UserMessage message={UserMessages.EmailMissing} type={messageType.Warning} />)
					}
					<div className="form-horizontal" sm={8}>
					{ 
						promptUser && (
							<div className="form-inline" style={{ marginLeft:'30px' }}>
								<div className="form-group">
                  <label htmlFor="prefix" style={{ paddingRight: '5px' }}>Member ID<span style={{ color: 'red' }}>*</span></label>
                  <input type="text" className="form-control" id="prefix" value={prefix} placeholder="Prefix" style={{ borderRadius: '0' }} maxLength="4" onChange={this.handleOnChange} autoFocus />
								</div>
								<div  className="form-group" style={{ maxWidth:'30px',marginLeft:'20px' }}>
                  <span>-</span>
								</div>
                <div className="form-group" style={{ marginLeft: '20px' }}>
                  <input type="text" className="form-control" placeholder='Suffix' id='suffix' value={suffix} maxLength="7" onChange={this.handleOnChange} style={{ borderRadius: '0' }} />
								</div>
								<div className="form-group">
									<DatePicker
										selected={this.state.dob}
										onChange={this.handleDateChange}
										placeholderText="Date of Birth (mm/dd/yyyy)"
										dateFormat="MM/DD/YYYY"	
										className="form-control dob"
										id="dob"
										maxDate={moment().subtract(12, 'years')}
									/>								
								</div> 
								<button className="btn btn-default" style={{ color:blue, minHeight:'34px', borderRadius:'0 2px 2px 0', marginLeft:'14px' }} onClick={this.handleMemberSearch} >
									<i className={searchicon} aria-hidden="true" />
								</button>
								<button className="btn btn-default" style={{ color: videoblue, fontSize:'14px',marginLeft:'5px', border:'0', textDecoration: 'underline' }} onClick={this.handleForgotMemberId}>Forgot Member ID?</button>
							</div>							
						)
					}					
					{ accountFound && requestSubmitted === false && ssoMembershipMismatch === false && ([<FormGroup key='1' style={{ fontSize: '16px' }}>
							<label className='col-sm-2 col-md-4 col-lg-3 control-label'>First Name:</label>
							<Col sm={8 }>
								<FormControl type="text" value={firstName}  className="form-control" readOnly  style={readOnly}/>
							</Col>
						</FormGroup>,
						<FormGroup  key='2' style={{ fontSize: '16px' }}>
							<label className='col-sm-2 col-md-4 col-lg-3 control-label'>Last Name:</label>
							<Col sm={8 }>
								<FormControl type="text" value={lastName}  className="form-control" readOnly style={readOnly} />
							</Col>
						</FormGroup>,
						<FormGroup  key='3' style={{ fontSize: '16px' }}>
							<label className='col-sm-2 col-md-4 col-lg-3 control-label'>Email:</label>
							<Col sm={8 }>
								<FormControl type="email" value={ emailAddress } className="form-control" readOnly style={readOnly}/>
							</Col>
							<Col smOffset={3} sm={8 }>
								{accountFound && emailAddress && <Button  style={{  color:blue, marginTop:'15px' }}   onClick={this.handleRequestAccess} disabled={submitting || !accountFound }>
									<h4>
										<i className={submittingIcon(saving,"fa fa-arrow-circle-right")}    aria-hidden="true" />
										&nbsp;&nbsp;{ UserMessages.RequestAccess }&nbsp;&nbsp;&nbsp;&nbsp;
									</h4>
								</Button>
                }
                {' '}
							</Col>
						</FormGroup>])
					}
                
        </div>

				{ requestSuccessful && (<UserMessage message={UserMessages.AccessRequestSubmmited} />) }
				{ pendingAccessRequest &&  (<UserMessage message={UserMessages.AccessRequestPending} />) }
			</div>
				</Panel>
      </Col>
      <footer style={{ paddingLeft:'34%' }}>
        <span style={{ color:'white' }}>&copy; 2017 - United States Bowling Congress. All rights reserved.</span>
      </footer>
    </Row>
	</div>)
  }
}
 
UserRegistration.propTypes = {
	oidc:object,
	user:object
}
const mapStateToProps = ({  oidc, user }) => {
	return {
		oidc: { ...oidc },
		user: { ...user }
	}
}
export default connect(mapStateToProps,null)(UserRegistration)


// WEBPACK FOOTER //
// ./src/containers/userregistration/index.js